<template>
    <div class="bannerWrap" v-if="lbIndexDto.adsBanner">
      <swiper
          class="bannerImg"
          :modules="modules"
          @swiper="onSwiper"
          @slideChange="onSlideChange"
          autoplay
          loop
          :navigation = "{
                nextEl: '.bannerWrap .swiper-button-next',
                prevEl: '.bannerWrap .swiper-button-prev',
                uniqueNavElements: true
           }"
          :pagination="{clickable: true}"
      >
        <swiper-slide v-for="(item, index) in lbIndexDto.adsBanner">
          <a :href="item.url" :title="item.tip">
            <img :src="getAdminImgUrl(item.imgUrl)"  :loading="index === 0 ? 'eager' : 'lazy'" :alt="item.tip" :key="index" fetchpriority="high"/>
          </a>
        </swiper-slide>
      </swiper>
      <div class="swiper-button-prev bannerPrev bannerPage hidden-xs"></div>
      <div class="swiper-button-next bannerNext  bannerPage hidden-xs"></div>
    </div>

    <!-- 倒计时 -->
    <Promotion class="hidden-sm hidden-md"></Promotion>

    <!-- 小屏模块 -->
    <div class="classification hidden-sm hidden-md" :class="{ 'hasClearence': isShowBigSale }">
      <ul>
        <li class="AllCategories"><a href="javascript:;" @click="handleOpenNavCate(true)"><span></span><i>All<br>Categories</i></a></li>
        <li class="SmartBargains"><a href="/small-lot/1.html"><span></span><i style="line-height: 28px;">Small Batch</i></a></li>
        <li class="PHJewelry"><a href="/Jewelry-Gallery.html"><span></span><i>Jewelry<br>Gallery</i></a></li>
        <li class="Sale" v-if="isShowBigSale"><a href="/promotion/1.html?promotionType=19"><span></span><i style="line-height: 28px;">Clearance</i></a></li>
        <li class="DailyDeals" @click="toggleHeadline()">
          <a href="javascript:;"><span></span><i>Holiday &  <br />Collections</i></a>
        </li>
      </ul>
    </div>

    <div class="navBox cls hidden-sm hidden-md" v-if="holiday && showHoliday">
      <dl class="wPopular">
        <dt>What's Popular</dt>
        <dd v-for="(item, index) in holiday['HeadLineBanner']">
          <a :href="item.url" :title="item.tip">
            <img :src="getAdminImgUrl(item.imgUrl)" :alt="item.tip">
          </a>
        </dd>

      </dl>
      <dl>
        <dt>{{holiday['HeadLineCategory1']['0'].url}}</dt>
        <dd v-for="(item1, index) in holiday['HeadLineText1']">
          <a :href="item1.url" :class="{'Icon_New': item1.promote==1}">
            {{item1.tip}}
            <span class="Icon_hot" v-if="item1.catId==1"></span>
          </a>
        </dd>

      </dl>
      <dl>
        <dt>{{holiday['HeadLineCategory2']['0'].url}}</dt>
        <dd v-for="(item2, index) in holiday['HeadLineText2']">
          <a :href="item2.url" :class="{'Icon_New': item2.promote==1}">
            {{item2.tip}}
            <span class="Icon_hot" v-if="item2.catId==1"></span>
          </a>
        </dd>

      </dl>
      <dl>
        <dt>{{holiday['HeadLineCategory3']['0'].url}}</dt>
        <dd v-for="(item3, index) in holiday['HeadLineText3']">
          <a :href="item3.url" :class="{'Icon_New': item3.promote==1}">
            {{item3.tip}}
            <span class="Icon_hot" v-if="item3.catId==1"></span>
          </a>
        </dd>
      </dl>
      <dl>
        <dt>{{holiday['HeadLineCategory4']['0'].url}}</dt>
        <dd v-for="(item4, index) in holiday['HeadLineText4']">
          <a :href="item4.url" :class="{'Icon_New': item4.promote==1}">
            {{item4.tip}}
            <span class="Icon_hot" v-if="item4.catId==1"></span>
          </a>
        </dd>
      </dl>
    </div>

    <template v-if="lbIndexDto.adsSmallBanner">
      <div class="couponBanner">
          <a v-for="(b, index) in lbIndexDto.adsSmallBanner" :href="b.url" :title="b.tip" :class="{'big':b.color}">
            <img :src="getAdminImgUrl(b.imgUrl)" width="224" height="85"  :alt="b.tip" />
          </a>
      </div>
    </template>

    <template v-if="lbIndexDto.productReviews && lbIndexDto.productReviews?.length > 0">
      <div class="customerReview" :style="customerReviewStyle">
        <h3 class="hidden-sm hidden-md">Customer Review</h3>
        <div>
          <swiper
              direction="vertical"
              :modules="modules"
              slides-per-view="1"
              :loop="true"
              :autoplay="{ delay: 3000, disableOnInteraction: false }"
              class="customerReviewSwiper"
          >
            <swiper-slide
                v-for="(review, index) in lbIndexDto.productReviews"
                :key="index"
                class="customerReviewSlide"
            >
              <p class="customerText" style="word-break: normal; margin:0;" :title="review.info2">
                {{ review.info2 }}
              </p>
              <span class="customerName">{{ review.info3 }}</span>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </template>

    <client-only>
      <ScrollLoading @load="onScrollLoading">
        <div v-if="isSignIn && lbIndexDto.specialBargainsForYou && lbIndexDto.specialBargainsForYou?.length > 0" class="special">
          <div class="specialEndTime">
            <h2>SPECIAL BARGAINS FOR YOU</h2>
            <a href="/special-bargains-for-you" class="more">More &gt;&gt;</a>

            <div class="productTime">
              <big>END IN</big>
              <p class="flashDeal_num cls">
                <span>{{ formatNumber(countdown.day) }}</span>
                <span class="fenj" style="font-size: 14px;">Day</span>
                <span>{{ formatNumber(countdown.hour) }}</span>
                <span class="fenj">:</span>
                <span>{{ formatNumber(countdown.minute) }}</span>
                <span class="fenj">:</span>
                <span>{{ formatNumber(countdown.second) }}</span>
              </p>
            </div>
          </div>

          <div class="specialShow">
            <swiper class="specialContainer" :modules="modules" loop :navigation="{ nextEl: '.specialShow .swiper-button-next', prevEl: '.specialShow .swiper-button-prev'}">
              <swiper-slide v-for="(group, groupIndex) in groupedProducts" :key="groupIndex">
                <ul class="cls" style="width: max-content;">
                  <li v-for="item in group" :key="item.id">

                    <p class="proImg">
                      <span class="GoCart AddToCartBtn" v-addToCart.stop="{ id: item.id, qty: 1 }">{{"product.add".translate()}}</span>
                      <span class="buyNow buyNowBtn" v-buyNow.stop="{ id: item.id, qty: 1 }">{{"product.buy".translate()}}</span>
                      <span v-if="!item.wishId" class="Collect addToWishListBtn" v-hoverAddToWishList.stop="item.id">{{"product.save".translate()}}</span>
                      <span v-if="item.wishId" class="Collect addToWishListBtn ViewMyWishList Collection"  v-hoverAddToWishList.stop="item.id"  :id="item.wishId" >Save</span>
                      <span v-if="item.isPoolProduct" class="hotIcon"></span>
                      <a :href="getProductDetailUrl(item.id, item.name)+'?paLb=Rec_Home_DailyDeal'" :title="item.name?.decodeHtml()">
                        <img :alt="item.name?.decodeHtml()"  v-lazy-load-img="{ photoName: item.mainImageName, size: 225, defaultImageUrl: '/imgs/load_1_1.gif' }" />
                      </a>
                    </p>
                    <p class="proName">
                      <a :href="getProductDetailUrl(item.id, item.name)+'?paLb=Rec_Home_DailyDeal'" :title="item.name?.decodeHtml()">
                        <span v-if="item.isPromotion" class="discountBg">{{ item.discount}}% OFF</span>
                        {{ item.name?.decodeHtml()}} ({{ item.code }})
                      </a>
                    </p>
                    <div class="rate">
                      <p class="proPrice red">
                        {{ item.finalSalePrice?.money() }} / <span class="unit">{{ getUnitString(item.unitQuantity, item.unit) }}</span>
                      </p>
                    </div>
                  </li>
                </ul>
              </swiper-slide>
            </swiper>

            <div class="swiper-button-next pageArrow nextArrow"></div>
            <div class="swiper-button-prev pageArrow prevArrow"></div>
          </div>
        </div>
        <!-- 推荐广告区块 -->
        <div v-if="lbIndexDto.couponsDeals && lbIndexDto.couponsDeals?.length" class="couponSDeals titleText">
          <p><span>HOT DEALS & RECOMMENDED</span></p>
          <div class="couponBanner">
            <template v-for="(b, idx) in lbIndexDto.couponsDeals" :key="idx">
              <a :href="b.info1" :title="b.title"><img :src="getAdminImgUrl(b.img1)" :alt="b.title" /></a>
            </template>
          </div>
        </div>

        <!-- 推荐分类/新品区块 -->
        <div v-if="lbIndexDto.recommendedCategories?.length || lbIndexDto.newArrivals?.length" class="commodityContent">
          <div class="commoditySectorNav">
            <dl>
              <dt></dt>
              <dd :class="{ current: activeTab === 'recommended' }" @click="activeTab = 'recommended'" v-if="lbIndexDto.recommendedCategories?.length">
                RECOMMENDED CATEGORIES
              </dd>
              <dd :class="{ current: activeTab === 'new' }" @click="activeTab = 'new'" v-if="lbIndexDto.newArrivals?.length">
                NEW ARRIVALS
              </dd>
            </dl>
          </div>

          <div class="commoditySector">
            <div class="commodityProductShow" v-show="activeList?.length > 0">
              <ul>
                <li v-for="item in activeList" :key="item.id">
                  <a :href="item.info1" :title="item.title">
                    <img :src="getAdminImgUrl(item.img1)" :alt="item.title" />
                    <span class="proName">{{ item.title }}</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>


        <div v-if="above3Products">
              <!-- WAP 分类滑块 -->
              <swiper class="X_Head hidden-sm hidden-md jsMenuSwiper" :slides-per-view="'auto'" space-between="10">
                <swiper-slide v-for="(c, index) in categoryTree" :key="index">
                  <a :class="{ 'on': (currentCategoryId == c.category.id || (index==0 && currentCategoryId==0))  }" @click="headHandleTabClick(c.category.id)" :data-mark="c.category.id">
                    {{ c.category.name }}
                  </a>
                  </swiper-slide>
              </swiper>
              <!-- 主内容 -->

              <div v-for="vo1 in categoryTree" :class="['promotionItem promotionItem' + vo1.category.id,{'isCurrent':(currentCategoryId == vo1.category.id || currentCategoryId==0)}]" :data-mark="vo1.category.id">

                <dl class="promotionNav hidden-xs">
                  <!-- 一级分类图和名称 -->
                  <dt>
                    <a :href="getCategoryUrl(vo1.category.name,vo1.category.id)">
                      {{lbIndexDto.categoryBannerName[vo1.category.id]}}
                    </a>
                  </dt>
                  <!-- 热门二级分类 -->
                  <dd v-for="(c2, i) in lbIndexDto.popularCategories[vo1.category.id]" :key="c2.id" :class="{ 'hot-category': c2.isHot }">
                    <a :href="getProductListShowModePageUrl(c2.name, c2.id,1,2)">
                      {{ c2.name.decodeHtml() }}
                    </a>
                  </dd>
                </dl>

                <!-- 商品展示 -->
                <div class="promotionShow">
                  <!-- 分类 Tab 滑块 (WAP) -->
                  <swiper :breakpoints="breakpoints" class="promotionCategory hidden-sm hidden-md" :slides-per-view="'auto'" space-between="10">
                    <swiper-slide class="wapTab" v-for="(tab, i) in categoryProductTabs" :key="i" :class="{ current: i === getCategoryActiveTab(vo1.category.id) }">
                      <span @click="handleTabClick(vo1.category.id, tab.key, i)">
                        <span>{{ tab.label }}</span>
                        <a v-if="i === getCategoryActiveTab(vo1.category.id)" :href="getSpecialAreaPageUrl(tab.areaType, vo1.category.id, vo1.category.name,1)">View More&gt;&gt;</a>
                      </span>
                    </swiper-slide>
                  </swiper>

                  <!-- 分类 Tab (PC) -->
                  <div class="promotionCategory hidden-xs">
                    <ul class="cls">
                      <li v-for="(tab, i) in categoryProductTabs" :key="i" :class="{ current: i === getCategoryActiveTab(vo1.category.id) }">
                        <span @click="handleTabClick(vo1.category.id, tab.key, i)">
                          {{ tab.label }}
                          <a v-if="tab.areaType" :href="getSpecialAreaPageUrl(tab.areaType,vo1.category.id,vo1.category.name,1)">View More&gt;&gt;</a>
                        </span>
                      </li>
                    </ul>
                  </div>

                  <div class="productShow">
                    <ul class="cls">
                      <li class="cls second-cate-li hidden-sm hidden-md">
                        <a v-for="c in lbIndexDto.popularCategories[vo1.category.id]" :key="c.id" :href="getProductListShowModePageUrl(c.name, c.id,1,2)">
                          {{ c.name.decodeHtml() }}
                        </a>
                      </li>
                      <li v-for="item in getCategoryProducts(vo1.category.id)" :key="item.id">

                        <p class="proImg">
                          <span class="GoCart AddToCartBtn" v-addToCart.stop="{ id: item.id, qty: 1 }">{{"product.add".translate()}}</span>
                          <span class="buyNow buyNowBtn" v-buyNow.stop="{ id: item.id, qty: 1 }">{{"product.buy".translate()}}</span>
                          <span v-if="!item.wishId" class="Collect addToWishListBtn" v-hoverAddToWishList.stop="item.id">{{"product.save".translate()}}</span>
                          <span v-if="item.wishId" class="Collect addToWishListBtn ViewMyWishList Collection"  v-hoverAddToWishList.stop="item.id"  :id="item.wishId" >Save</span>
                          <span v-if="item.isPoolProduct" class="hotIcon"></span>
                          <a :href="getProductDetailUrl(item.id, item.name)+'?paLb=Rec_Home_DailyDeal'" :title="item.name?.decodeHtml()">
                            <img :alt="item.name?.decodeHtml()"  v-lazy-load-img="{ photoName: item.mainImageName, size: 220, defaultImageUrl: '/imgs/load_1_1.gif' }" />
                          </a>
                        </p>
                        <p class="proName">
                          <a :href="getProductDetailUrl(item.id, item.name)+'?paLb=Rec_Home_DailyDeal'" :title="item.name?.decodeHtml()">
                            <span v-if="item.isPromotion" class="discountBg">{{ item.discount}}% OFF</span>
                            {{ item.name?.decodeHtml()}} ({{ item.code }})
                          </a>
                        </p>
                        <div class="rate">
                          <p class="proPrice red">
                            {{ item.finalSalePrice?.money() }} / <span class="unit">{{ getUnitString(item.unitQuantity, item.unit) }}</span>
                          </p>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
      </ScrollLoading>
    </client-only>
  <!-- 优惠券弹窗 -->
  <div id="showReviewBoxOverlay" v-if="lbIndexDto.coupons && lbIndexDto.coupons.length && showCouponBox">
    <div id="showCouponBox" :class="`coupon_${lbIndexDto.coupons.length}`">
      <div class="couponBox">
        <div class="couponGo">
          <dl>
            <dt @click="closeCouponBox()"></dt>
            <template v-for="c in lbIndexDto.coupons">
              <dd :class="{'current':c.isClicked}">
                <div>
                  <p>
                      <b v-if="c.couponFacebookType === 'CashSubstract'">${{ c.couponValue }}</b>
                      <b v-if="c.couponFacebookType === 'Rebate' || c.couponFacebookType === 'PaypalRebate'">{{ c.couponValue }}%</b>
                  </p>
                  <p>{{ c.platformType }}</p>
                  <p>{{ c.startDate.formatDate() }} -- {{ c.endDate.formatDate() }}</p>
                </div>
                <div>
                  <a :coupon="c.facebookCode" class="getCoupon" href="javascript:;" @click="getCoupon(c)"></a>
                </div>
              </dd>
            </template>
          </dl>
          <span class="bestrow">
            Don’t forget <br>
            to use <br>
            while checking out.
          </span>
        </div>
        <p><a href="/Coupon">My Coupon &gt;&gt;</a></p>
      </div>
    </div>
  </div>

  <!-- 手机弹窗 -->
    <div class="ms-category-mask" v-if="isShowNavCate == true" :style="winStyle"></div>
    <section class="ms-category-drawer hidden-sm hidden-md" :class="{'open': isShowNavCate == true}" :style="winStyle">
      <div class="ms-category-head">
        <a class="ms-category-logo" href="/"><img src="@/assets/images/header/logo.png" alt="lbeads"></a>
        <span class="ms-category-cancel" @click="handleOpenNavCate(false)"></span>
      </div>
      <div class="navList">
        <ul class="categoriesList">
          <li><a class="ms-second-category" href="/wholesale-jewelry-beads/2.html">Jewelry Beads<em></em></a></li>
          <li><a class="ms-second-category" href="/wholesale-jewelry-findings/3.html">Jewelry Findings<em></em></a></li>
          <li><a class="ms-second-category" href="/wholesale-beading-supplies/4.html">Beading Supplies<em></em></a></li>
          <li><a class="ms-second-category" href="/wholesale-stringing-materials/5.html">Stringing Materials<em></em></a></li>
          <li><a class="ms-second-category" href="/wholesale-jewelry-watches/6.html">Jewelry &amp; Watches<em></em></a></li>
          <li><a class="ms-second-category" href="/wholesale-beauty-personal-care/551.html">Beauty &amp; Personal Care<em></em></a></li>
          <li><a class="ms-second-category" href="/wholesale-sewing-diy-crafts/736.html">Sewing &amp; DIY Crafts<em></em></a></li>
          <li><a class="ms-second-category" href="/wholesale-office-home-garden/901.html">Office &amp; Home &amp; Garden<em></em></a></li>
        </ul>
      </div>
    </section>
</template>

<script src="./Index.ts"></script>
<style src="./index.less" scoped lang="less"></style>